import React, { ComponentProps, FC, RefObject } from 'react';

import { useFullscreen } from '@/scenarios/legacy-player/components/PlayerSkin/parts/Layout/hooks/useFullscreen';

import { FullSizePlayerLayout } from '../../../feature-player/ui/skin/full-size-player-layout/component';
import { useToggleOnAirWithIndicator } from '../../../feature-player/hooks/skin/use-toggle-on-air-with-indicator';

interface SportLayoutProps
    extends Omit<ComponentProps<typeof FullSizePlayerLayout>, 'onClick' | 'onDoubleClick'> {
    rootContainerRef: RefObject<HTMLDivElement> | null;
}

export const SportLayout: FC<SportLayoutProps> = ({ rootContainerRef, ...props }) => {
    const { toggleFullscreen } = useFullscreen();
    const { toggleOnAir } = useToggleOnAirWithIndicator();

    return (
        <FullSizePlayerLayout onDoubleClick={toggleFullscreen} onClick={toggleOnAir} {...props} />
    );
};
